import update from 'immutability-helper';

import {
    SET_NEXT_PREVIEWS_INFO,
    SET_SEARCH_TEXT,
    SET_TRACK,
    SET_UNAUTHENTICATED,
} from '../types';

const initialState = {
    nextPreviewsInfo: null,
    searchText: '',
    track: null,

};


export default function (state = initialState, action) {
    switch (action.type) {
        case SET_NEXT_PREVIEWS_INFO:
            return {
                ...state,
                nextPreviewsInfo: action.payload,
            };
        case SET_SEARCH_TEXT:
            return {
                ...state,
                searchText: action.payload,
            };
        case SET_TRACK:
            const track = action.payload;
            return {
                ...state,
                // track: action.payload,
                track: track,
            };
        case SET_UNAUTHENTICATED:
            return {
                ...initialState,
            };
        default:
            return state;
    }
};